import { render } from "./designReward.vue?vue&type=template&id=2253a58f&scoped=true"
import script from "./designReward.vue?vue&type=script&lang=js"
export * from "./designReward.vue?vue&type=script&lang=js"

import "./designReward.vue?vue&type=style&index=0&id=2253a58f&lang=less&scoped=true"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2253a58f"]])

export default __exports__